import React, {useState, useEffect, useMemo} from 'react';
import Header from '../../container/Header/Header.js';
import Footer from '../../container/Footer/Footer.js';
import {Container, Row, Col, Badge} from 'react-bootstrap';
import ReturnLink from './../../components/ReturnLink/ReturnLink.js';
//import CardSubEvent from '../../components/CardSubEvent/CardSubEvent.js';
import CardSubEvent from '../../components/CardSubEventV3/CardSubEventV3.js';
import ActivityDetailsModal from '../../components/ActivityDetailsModal/ActivityDetailsModal.js';
import PastilleDate from './../../components/PastilleDate/PastilleDate.js';
import {Helmet} from "react-helmet";
import axios from "axios";
import variables from "./../../variables.js";
 
import './Evenement.scss';

function activityGroupKey(row) {
    return String(row.id);
}

function dayMatchesEventRow(row, day) {
    if (!day) return true;
    const dateEvent = row.date_event ? String(row.date_event).split('-') : [];
    if (dateEvent.length === 0) return true;
    return day === dateEvent[0];
}

function parseArtistNamesFromRow(row) {
    if (!row.artist) return [];
    const raw = String(row.artist);
    const parts = raw.includes(',') ? raw.split(',') : [raw];
    return parts.map((s) => s.trim()).filter(Boolean);
}

function mergeArtistNames(rows) {
    const seen = new Set();
    const out = [];
    rows.forEach((row) => {
        parseArtistNamesFromRow(row).forEach((n) => {
            if (!seen.has(n)) {
                seen.add(n);
                out.push(n);
            }
        });
    });
    return out;
}

function buildThumbnailsFromRows(rows, imageBase) {
    const bySrc = new Map();
    rows.forEach((row) => {
        if (!row.image_src) return;
        const firstPart = String(row.image_src).split('|')[0];
        const src = imageBase + firstPart;
        const names = parseArtistNamesFromRow(row);
        if (!bySrc.has(src)) {
            bySrc.set(src, {
                src,
                credit: row.credits || null,
                artists: new Set(names),
            });
        } else {
            const entry = bySrc.get(src);
            names.forEach((n) => entry.artists.add(n));
        }
    });
    return Array.from(bySrc.values()).map((entry) => ({
        src: entry.src,
        credit: entry.credit,
        artists: Array.from(entry.artists),
    }));
}
 
const Evenement = (props) => {
    const {id,day} = props;
    const [pageData,setPageData]=useState();
    const [events,setEvents]=useState();
    const [categs,setCategs]=useState();
    const [currCateg,setCurrCateg]=useState([]);
    const [artists,setArtists]=useState();
    const [currArtist,setCurrArtist]=useState([]);
    const [lastClickedArtist, setLastClickedArtist] = useState(null);
    const [detailsModalGroup, setDetailsModalGroup] = useState(null);
    const [eventTypeByName, setEventTypeByName] = useState({});
    const [eventTypeById, setEventTypeById] = useState({});
    const [artistByName, setArtistByName] = useState({});
    const [artistById, setArtistById] = useState({});
    const [initialFiltersApplied, setInitialFiltersApplied] = useState(false);
    useEffect(()=>{
        if(!pageData){
            console.log('useEffect: Fetching pageData', id);
            axios({
                method:'get',
                url:variables.site+'/events/'+id,
                //headers:pixheaders
            }).then(function(response){
                //console.log(response);
                if(response.status === 200){
                    console.log('pageData fetched:', response.data.data); 
                    setPageData(response.data.data);
                }
            })
        }
    }, [id, pageData]);

    // Reset events when pageData changes to prevent accumulation
    useEffect(() => {
        console.log('useEffect: Resetting events on pageData change', pageData);
        setEvents(null);
    }, [pageData]);

    // Fetch lookups (event types and artists) to map names <-> IDs
    useEffect(()=>{
        console.log('useEffect: Fetching lookups');
        if(Object.keys(eventTypeByName).length === 0){
            axios({ method:'get', url:variables.site+'/eventstypes' }).then(function(response){
                if(response.status === 200){
                    const byName = {}; const byId = {};
                    response.data.data.forEach((et)=>{ byName[et.name] = et.id; byId[et.id] = et.name; });
                    setEventTypeByName(byName); setEventTypeById(byId);
                    console.log('eventTypeByName', byName);
                    console.log('eventTypeById', byId);
                }
            });
        }
        if(Object.keys(artistByName).length === 0){
            axios({ method:'get', url:variables.site+'/artists' }).then(function(response){
                if(response.status === 200){
                    const byName = {}; const byId = {};
                    response.data.data.forEach((a)=>{ byName[a.name] = a.id; byId[a.id] = a.name; });
                    setArtistByName(byName); setArtistById(byId);
                    console.log('artistByName', byName);
                    console.log('artistById', byId);
                }
            });
        }
    },[eventTypeByName, artistByName])

    // Preselect from URL IDs once lookups and lists are ready
    useEffect(()=>{
        console.log('useEffect: Preselecting from URL. eventTypeById loaded:', Object.keys(eventTypeById).length > 0, 'artistById loaded:', Object.keys(artistById).length > 0, 'categs loaded:', Array.isArray(categs), 'artists loaded:', Array.isArray(artists));
        if(initialFiltersApplied || Object.keys(eventTypeById).length === 0 || Object.keys(artistById).length === 0 || !Array.isArray(categs) || !Array.isArray(artists)) return;

        let urlDefaults = new URLSearchParams(window.location.search);
        const urlActivites = urlDefaults.get('activites');
        const urlArtists = urlDefaults.get('artists');

        let initialSelectedCategs = [];
        if(urlActivites){ initialSelectedCategs = urlActivites.split(',').map(id => eventTypeById[id]).filter(Boolean); }

        let initialSelectedArtists = [];
        if(urlArtists){ initialSelectedArtists = urlArtists.split(',').map(id => artistById[id]).filter(Boolean); }

        // Only update if there are actual selections from the URL to prevent overwriting user interactions
        if(initialSelectedCategs.length > 0){ 
            setCurrCateg(initialSelectedCategs);
            console.log('Preselecting categories from URL:', initialSelectedCategs);
        }
        if(initialSelectedArtists.length > 0){ 
            setCurrArtist(initialSelectedArtists);
            console.log('Preselecting artists from URL:', initialSelectedArtists);
        }
        setInitialFiltersApplied(true);
    },[eventTypeById, artistById, categs, artists, initialFiltersApplied]); // Removed currCateg and currArtist from dependencies

    useEffect(()=>{
        if(pageData && !events){ // Condition to fetch if pageData is available and events is null
            console.log('useEffect: Fetching events for pageData', pageData.eventsactivities);
            //console.log(variables.site+pageData.eventsactivities);
            axios({
                method:'get',
                url:variables.site+pageData.eventsactivities,
                //headers:pixheaders
            }).then(function(response){
                //console.log(response);
                if(response.status === 200){
                    console.log('Events fetched and sorted:', response.data.data);
                    //setEvents(Object.keys(response.data.data).sort().reduce((r, k) => (r[k] = response.data.data[k], r), {}));
                    const sortedEvents = response.data.data.sort((a,b) => {
                        let adate = a.date_event.split('-')
                        let bdate = b.date_event.split('-')
                        if(adate[0] > bdate[0]){
                            return 1;
                        }else if(a.heure_debut > b.heure_debut){
                            return 1;
                        }else{
                            return -1;
                        }
                    });
                    setEvents(sortedEvents);

                    //setCurrCateg('Toutes les activités') // This will be handled by URL preselection or default empty array
                    var categs = [];
                    var artists = [];
                    //var initialSelectedCategs = [];
                    //var initialSelectedArtists = [];

                    //let urlDefaults = new URLSearchParams(window.localStorage.getItem('currentsearch') || window.location.search);
                    //const urlActivites = urlDefaults.get('activites');
                    //const urlArtists = urlDefaults.get('artists');

                    //if(urlActivites){ initialSelectedCategs = urlActivites.split(',').map(id => eventTypeById[id]).filter(Boolean); }
                    //if(urlArtists){ initialSelectedArtists = urlArtists.split(',').map(id => artistById[id]).filter(Boolean); }

                    sortedEvents.forEach(result=>{
                        if(result.type && !categs.includes(result.type)){
                            let dateEvent = result.date_event.split('-');
                            if(day && day !== dateEvent[0]){
 
                            }else{
                                categs.push(result.type)
                            }
                        }
                        if(result.artist){
                            // result.artist can be a single name or a string containing multiple names
                            // Attempt to split by comma if multiple artists are present
                            let raw = String(result.artist);
                            let names = raw.indexOf(',') !== -1 ? raw.split(',') : [raw];
                            names.map(n => {
                                const name = n.trim();
                                if(name && !artists.includes(name)){
                                    artists.push(name)
                                }
                                return false;
                            })
                        }
                        return false;
                    })
                    setCategs(categs);
                    setArtists(artists.sort()); // Sort artists alphabetically

                    // Set initial states based on parsed URL parameters
                    //setCurrCateg(initialSelectedCategs.length > 0 ? initialSelectedCategs : []);
                    //setCurrArtist(initialSelectedArtists.length > 0 ? initialSelectedArtists : []);
                }
            })
        }
    }, [pageData, day, eventTypeById, artistById, events]); // Added events to ensure re-run if lookups are not loaded

    // Preselect from URL IDs once lookups and lists are ready
    /*useEffect(()=>{
        console.log('useEffect: Preselecting from URL. LookupsLoaded:', lookupsLoaded, 'categs:', categs, 'artists:', artists);
        if(!lookupsLoaded || !Array.isArray(categs) || !Array.isArray(artists)) return;
        let urlDefaults = new URLSearchParams(window.location.search);
        const urlActivitesId = urlDefaults.get('activites');
        if(urlActivitesId && eventTypeById[urlActivitesId]){
            const name = eventTypeById[urlActivitesId];
            console.log('Preselecting category from URL:', urlActivitesId, '->', name);
            if(categs.includes(name)) setCurrCateg(name);
        }
        const urlArtistId = urlDefaults.get('artists');
        if(urlArtistId && artistById[urlArtistId]){
            const name = artistById[urlArtistId];
            console.log('Preselecting artist from URL:', urlArtistId, '->', name);
            if(artists.includes(name)) setCurrArtist(name);
        }
    },[lookupsLoaded, categs, artists, eventTypeById, artistById]) // Keep this useEffect for preselection*/
    // Sync URL when filters change (use IDs) - Re-adding this block
    useEffect(()=>{
        console.log('useEffect: Syncing URL. currCateg:', currCateg, 'currArtist:', currArtist);
        if(!initialFiltersApplied) return; // Prevent URL reset on initial load
        const { pathname, search } = window.location;
        const params = [];

        if(currCateg && currCateg.length > 0){
            const ids = currCateg.map(name => eventTypeByName[name]).filter(Boolean);
            if(ids.length > 0){ params.push('activites='+encodeURIComponent(ids.join(','))); }
        }
        if(currArtist && currArtist.length > 0){
            const ids = currArtist.map(name => artistByName[name]).filter(Boolean);
            if(ids.length > 0){ params.push('artists='+encodeURIComponent(ids.join(','))); }
        }

        const queryString = params.length ? '?'+params.join('&') : '';
        if(search !== queryString){
            window.history.pushState({},"",pathname+queryString);
            console.log('URL updated to:', pathname+queryString);
        }
    },[currCateg, currArtist, eventTypeByName, artistByName, initialFiltersApplied]);
    const filteredEvents = useMemo(()=>{
        console.log('useMemo: Filtering events. Events count:', events ? events.length : 0, 'currCateg:', currCateg, 'currArtist:', currArtist, 'day:', day);
        if(!Array.isArray(events)) return [];
        return events.filter((result)=>{
            let matchesCategory = true;
            if (currCateg.length > 0) {
                matchesCategory = currCateg.includes(result.type);
            }

            let matchesArtist = true;
            if (currArtist.length > 0) {
                const artistValue = result.artist ? String(result.artist) : '';
                const eventArtists = artistValue.split(',').map(a => a.trim()).filter(Boolean);
                matchesArtist = currArtist.some(selectedArtist => eventArtists.includes(selectedArtist));
            }

            let categoryOrArtistMatch = false;
            if (currCateg.length === 0 && currArtist.length === 0) {
                categoryOrArtistMatch = true;
            } else if (currCateg.length > 0 && currArtist.length === 0) {
                categoryOrArtistMatch = matchesCategory;
            } else if (currCateg.length === 0 && currArtist.length > 0) {
                categoryOrArtistMatch = matchesArtist;
            } else {
                categoryOrArtistMatch = matchesCategory || matchesArtist;
            }

            let dayMatch = true;
            if (day) {
                const dateEvent = result.date_event ? String(result.date_event).split('-') : [];
                if (dateEvent.length > 0 && day !== dateEvent[0]) {
                    dayMatch = false;
                }
            }

            return categoryOrArtistMatch && dayMatch;
        });
    },[events, currCateg, currArtist, day]);

    const groupedEventsForCards = useMemo(() => {
        if (!Array.isArray(events) || !Array.isArray(filteredEvents) || filteredEvents.length === 0) {
            return [];
        }
        const visibleKeySet = new Set();
        const visibleKeys = [];
        filteredEvents.forEach((row) => {
            const key = activityGroupKey(row);
            if (!visibleKeySet.has(key)) {
                visibleKeySet.add(key);
                visibleKeys.push(key);
            }
        });
        const byKeyFull = new Map();
        events.forEach((row) => {
            if (!dayMatchesEventRow(row, day)) return;
            const key = activityGroupKey(row);
            if (!visibleKeySet.has(key)) return;
            if (!byKeyFull.has(key)) byKeyFull.set(key, []);
            byKeyFull.get(key).push(row);
        });
        return visibleKeys.map((key) => {
            const rows = byKeyFull.get(key) || [];
            const pivot = rows[0];
            const artistNames = mergeArtistNames(rows);
            const thumbnails = buildThumbnailsFromRows(rows, variables.imageSource);
            return { key, pivot, artistNames, thumbnails, rows };
        });
    }, [events, filteredEvents, day]);

    if(pageData){
        console.log('Rendering with filteredEvents count:', filteredEvents.length);
        var date = pageData.date_event.split('-');
        if(day){
            date = new Array(day);
        }
        const returnLinkHref = window.localStorage.getItem('currentsearch') ? window.localStorage.getItem('currentsearch') : '/';
        return (<div className="page-evenement">
            <Helmet>
                <title>{pageData.name} - Fête nationale du Québec</title>
            </Helmet>
            <div className="bg-head">
                <Header />
                <Container className="mt-8 pb-md-12 pb-5">
                    <ReturnLink href={returnLinkHref} text="Retour aux résultats" variant="nav" />
                    <div className="d-flex flex-wrap align-items-end justify-content-between">
                        <Col md="8"><h2 className="text-white mt-mb-6 mt-4">{pageData.name}</h2></Col>
                        <Col md="4" className="text-right d-none d-md-block"><PastilleDate date={date[0]} /></Col>
                    </div>
                </Container>
            </div>
            <Container className="pb-12 eventsList">
                <div className="d-block d-md-none"><PastilleDate date={date[0]} /></div>
                <div className="pt-6 pb-6">
                    <div className="eventTags">
                        <div>
                            {(Array.isArray(categs) && categs.length !== 0) && (
                                <Badge
                                    as="button"
                                    type="button"
                                    pill
                                    key="Toutes les activités"
                                    className={currCateg.length === 0 && currArtist.length === 0 ? "mb-2 is-active" : "mb-2"}
                                    aria-pressed={currCateg.length === 0 && currArtist.length === 0}
                                    aria-label="Afficher toutes les activités et retirer les filtres"
                                    onClick={()=>{
                                        setCurrCateg([]);
                                        setCurrArtist([]);
                                        setLastClickedArtist(null);
                                    }}
                                >
                                    Toutes les activités
                                </Badge>
                            )}
                            {(Array.isArray(categs) && categs.length !== 0) && categs.map(categ=>(
                                <Badge
                                    as="button"
                                    type="button"
                                    pill
                                    key={categ}
                                    className={currCateg.includes(categ) ? "mb-2 is-active" : "mb-2"}
                                    aria-pressed={currCateg.includes(categ)}
                                    aria-label={`Filtrer par la catégorie ${categ}`}
                                    onClick={()=>{
                                        setCurrCateg(prev => {
                                            if(prev.includes(categ)){
                                                return prev.filter(c => c !== categ);
                                            }else{
                                                return [...prev, categ];
                                            }
                                        });
                                    }}
                                >
                                    {categ}
                                </Badge>
                            ))}
                            {(Array.isArray(artists) && artists.length !== 0) && artists.map(artist=>(
                                <Badge
                                    as="button"
                                    type="button"
                                    pill
                                    key={artist}
                                    className={currArtist.includes(artist) ? "mb-2 is-active" : "mb-2"}
                                    aria-pressed={currArtist.includes(artist)}
                                    aria-label={`Filtrer par l'artiste ${artist}`}
                                    onClick={()=>{
                                        setLastClickedArtist(artist);
                                        setCurrArtist(prev => {
                                            if(prev.includes(artist)){
                                                return prev.filter(a => a !== artist);
                                            }
                                            return [...prev, artist];
                                        });
                                    }}
                                >
                                    {artist}
                                </Badge>
                            ))}
                        </div>
                    </div>
                </div>
                <Row>
                    {groupedEventsForCards.map(({ key, pivot, artistNames, thumbnails }) => {
                        const dateEvent = pivot.date_event.split('-');
                        const firstThumb = thumbnails[0];
                        return (
                            <Col lg="3" md="4" sm="6" className="mb-md-3 mb-1" key={key}>
                                <CardSubEvent
                                    id={key}
                                    datetime={pivot.heure_debut}
                                    heure_debut={pivot.heure_debut}
                                    heure_fin={pivot.heure_fin}
                                    date={dateEvent[0]+' juin'}
                                    thumbnail={firstThumb ? firstThumb.src : null}
                                    thumbnail_credit={firstThumb ? firstThumb.credit : null}
                                    thumbnails={thumbnails.length > 1 ? thumbnails : undefined}
                                    titre={pivot.name}
                                    adresse={pivot.adresse_site + ', ' + pivot.city + ', ' + pivot.code_postal}
                                    location_nicename={pivot.lieu_precis}
                                    categorie={pivot.type}
                                    subCategorie={pivot.sub_type}
                                    animation={pivot.animation}
                                    animateur={pivot.animateur}
                                    artistNames={artistNames}
                                    artiste={artistNames.join(', ')}
                                    chorale={pivot.chorale}
                                    releve={pivot.releve}
                                    representants={pivot.representants ? pivot.representants : null}
                                    activeArtistFilter={currArtist}
                                    lastClickedArtist={lastClickedArtist}
                                    onOpenDetails={() =>
                                        setDetailsModalGroup({
                                            pivot,
                                            artistNames,
                                            thumbnails,
                                        })
                                    }
                                />
                            </Col>
                        );
                    })}
                </Row>
            </Container>

            <ActivityDetailsModal
                show={!!detailsModalGroup}
                onHide={() => setDetailsModalGroup(null)}
                activityGroup={detailsModalGroup}
            />
                
            <Footer/>
        </div>);
    }else{
        return (<div className="page-evenement">
            <Helmet>
                <title>Chargement - Fête nationale du Québec</title>
            </Helmet>
            <div className="bg-head">
                <Header />
                <Container className="mt-8 pb-12">
                    <ReturnLink href="/" text="Retour aux résultats" variant="nav" />
                    <div className="d-flex flex-wrap align-items-end justify-content-between">
                        <Col md="6"><h2 className="text-white mt-6">Chargement</h2></Col>
                    </div>
                </Container>
            </div>
        </div>)
    }
}
export default Evenement;